// modulos
export const ACCOUNT = 'account';
export const CAMPANHA = 'campanha';
export const PAINEL = 'painel';
export const CATEGORIA = 'categoria';
export const EMPRESA = 'empresa';
export const FATOR = 'fator';
export const META = 'meta';
export const USER = 'user';
export const GRUPO = 'grupo';
export const GRUPO_CONTROLE = 'grupo-de-controle';
export const LOJA = 'loja';
export const COLABORADOR = 'colaborador';
export const CURVA_ABC = 'curva-abc';
export const EXCESSO_ESTOQUE = 'excesso-de-estoque';
export const LOGIN_ADMIN = 'login-admin';
export const STATUS_EMPRESA = 'status-empresa';
export const CLASSIFICACAO_DE_LOJA = 'classificacao-de-loja';
export const MOTIVO_STATUS_EMPRESA = 'motivo-status-empresa';
export const PARAMETROS_BI = 'parametros-bi';
export const PARAMETROS_INTEGRACAO = 'parametros-integracao';
export const PARAMETROS_GLOBAIS = 'parametros-globais';

// permissions
export const CREATE = 'create';
export const READ = 'read';
export const UPDATE = 'update';
export const DELETE = 'delete';
export const ASSIGN = 'assign';
